module.exports = __webpack_public_path__ + "img/penilaian.65386840.svg";